/**
 * Converts a phone number string into a clean `tel:` href value.
 * Keeps a leading `+` for international prefixes and strips everything else
 * that is not a digit.
 */
export const getTelHref = (phone: string): string => {
	const digits = phone.replace(/[^\d+]/g, '');
	return `tel:${digits}`;
};
